/* ════ RESIZE BLOCKS (drag the left/right edge) ════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { startHalf, endHalf, halfRangeToDates } from './util.js';
import { dbUpdate } from '../supabase/data.js';
import { updateEdgeScroll, stopEdgeScroll } from './edgescroll.js';
import { suppressClick } from './dragguard.js';
import { pushUndo } from './undo.js';
import { showToast } from '../utils/toast.js';

// edge: 'l' (move start) or 'r' (move end). Snaps to half-days.
export function startResize(e, tid, edge) {
  e.preventDefault(); e.stopPropagation();
  const task = state.tasks.find(t => t.id === tid); if (!task || task.locked) return;
  const el = $(`tb-${tid}`), ts = $('tl-scroll'), sec = el.closest('.res-sec');
  const HW = state.DAY_W / 2;
  let sh = startHalf(task), eh = endHalf(task);
  el.classList.add('resizing');

  const pointerHalf = clientX => Math.round((clientX - sec.getBoundingClientRect().left + ts.scrollLeft) / HW);

  const apply = () => {
    const left = sh * HW + 1, w = Math.max((eh - sh) * HW - 3, 14);
    el.style.left = `${left}px`; el.style.width = `${w}px`;
  };
  const onMove = ev => {
    const ph = pointerHalf(ev.clientX);
    if (edge === 'r') eh = Math.max(sh + 1, ph);
    else sh = Math.max(0, Math.min(eh - 1, ph));
    apply();
    updateEdgeScroll(ev.clientX);
  };
  const onUp = () => {
    document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp);
    stopEdgeScroll(); el.classList.remove('resizing'); suppressClick();
    const { start, end, half } = halfRangeToDates(sh, eh);
    pushUndo({ id: tid, before: { start: task.start, end: task.end, half: task.half, resource: task.resource } });
    dbUpdate(tid, { start, end, half });
    showToast('Resized · Ctrl+Z to undo');
  };
  document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
}
